import { SplitPayments } from "../../pages";
import { SplitPaymentsController } from "../../controllers";
import React, { useEffect, useMemo, useState } from "react";
import { getDate } from "../../utils/utils";
import { filterPeriods } from "../../utils/utils";

const SplitPaymentsContainer = () => {
  const [limit, setLimit] = useState(50);
  const [filterQuery, setFilterQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const setTransactions = async () => {
      setLoading(true);
      await SplitPaymentsController.splitAnalysis();
      setLoading(false);
    };
    setTransactions();
  }, []);

  const splitPaymentTableQuery = useMemo(() => {
    return `offset=${currentPage + 1}&limit=${limit}`;
  }, [currentPage, limit]);

  const { isLoading, data, isFetching } =
    SplitPaymentsController.useGetSplitPayments(
      splitPaymentTableQuery,
      filterQuery,
      searchQuery
    );

  const onLimitChange = (limit) => {
    setLimit(limit);
    setCurrentPage(0);
  };

  const filterHandler = async (query) => {
    setFilterQuery(query);
  };

  return (
    <SplitPayments
      getDate={getDate}
      filterPeriods={filterPeriods}
      isLoading={isLoading}
      data={data}
      isFetching={isFetching}
      limit={limit}
      onLimitChange={onLimitChange}
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      setSearchQuery={setSearchQuery}
      setFilterQuery={setFilterQuery}
      filterHandler={filterHandler}
      loading={loading}
    />
  );
};

export default SplitPaymentsContainer;
